export default __webpack_public_path__ + "static/media/ArrowDownWhite.133d2455.svg";